import type { ComponentType, ReactNode } from "react"
import AdminLayout from "~/layouts/admin-layout"
import PublicLayout from "~/layouts/public-layout"

type PageComponent = ComponentType<Record<string, unknown>> & {
  layout?: (page: ReactNode) => ReactNode
}

const pages = import.meta.glob<{ default: PageComponent }>("../pages/**/*.tsx")

/*
 * ページ名（controller/action）から component を引き、既定のレイアウトを被せる。
 * クライアント入口と SSR 入口の両方が同じものを使う —— ここが 2 つに分かれると
 * サーバとクライアントで違う HTML が出て、ハイドレーションがずれる。
 *
 * レイアウトの決定はここ 1 箇所に集める。ページ側で `Page.layout` を明示して
 * いればそちらを尊重するので、レイアウトを持たない画面（ログインなど）は
 * ページ側で `Page.layout = (page) => page` を入れればよい。
 */
export default async function resolvePage(name: string): Promise<PageComponent> {
  const loader = pages[`../pages/${name}.tsx`]
  if (!loader) throw new Error(`Page not found: ${name}`)

  const component = (await loader()).default
  if (component.layout === undefined) {
    component.layout = name.startsWith("admin/")
      ? (page) => <AdminLayout>{page}</AdminLayout>
      : (page) => <PublicLayout>{page}</PublicLayout>
  }
  return component
}
